/**
 * DEV-959. Авто-запоминание URL списка + резолв точки возврата.
 *
 * В списке — вызвать один раз в setup(): пока список смонтирован, каждое изменение
 * его query автоматически запоминается, руками звать remember не нужно.
 * В точке возврата (хлебная крошка, кнопки «Назад») — вызвать resolveListPath(fallback)
 * при построении to/router.push, чтобы вернуться с сохранёнными фильтрами.
 *
 * Имя роута (route.name) должно совпадать с ListSection — сверено с router/index.ts.
 */
import { watch } from 'vue'
import { useRoute } from 'vue-router'
import { useListNavigationStore, type ListSection } from '@/stores/listNavigation.store'

export function useListReturnNav(section: ListSection) {
  const store = useListNavigationStore()
  const route = useRoute()

  watch(
    () => route.fullPath,
    (fullPath) => {
      if (route.name === section) store.rememberUrl(section, fullPath)
    },
    { immediate: true },
  )

  /** Путь для «вернуться в список»: запомненный URL с фильтрами или голый fallback. */
  const resolveListPath = (fallback: string): string => store.urlFor(section) ?? fallback

  return { resolveListPath }
}
